import React from 'react';
import {
    Dialog, DialogContent, DialogHeader, DialogTitle
} from 'shared/components/ui/dialog';
import {
    Progress
} from 'shared/components/ui/progress';
import {
    CheckCircle, XCircle, Clock, Upload
} from 'lucide-react';

const UploadManagerDialog = ({
    isOpen, onClose, uploadProgress
}) => {
    const getStatusIcon = (status) => {
        switch (status) {
            case 'completed':
                return <CheckCircle className="w-4 h-4 text-green-500" />;
            case 'failed':
                return <XCircle className="w-4 h-4 text-red-500" />;
            case 'uploading':
                return <Upload className="w-4 h-4 text-blue-500" />;
            default:
                return <Clock className="w-4 h-4 text-gray-500" />;
        }
    };

    const getStatusText = (status) => {
        switch (status) {
            case 'completed':
                return 'Completed';
            case 'failed':
                return 'Failed';
            case 'uploading':
                return 'Uploading';
            default:
                return 'Pending';
        }
    };

    const totalFiles = uploadProgress.length;
    const completedFiles = uploadProgress.filter(f => f.status === 'completed').length;
    const failedFiles = uploadProgress.filter(f => f.status === 'failed').length;

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
                <DialogHeader>
                    <DialogTitle>Uploading Files</DialogTitle>
                    <p className="text-sm text-muted-foreground">
                        {completedFiles + failedFiles} of {totalFiles} files processed
                    </p>
                </DialogHeader>

                <div className="space-y-4">
                    {uploadProgress.map((file, index) => (
                        <div key={index} className="flex items-center space-x-3 p-3 border rounded-lg">
                            {getStatusIcon(file.status)}
                            <div className="flex-1 min-w-0">
                                <p className="text-sm font-medium truncate">{file.name}</p>
                                <p className="text-xs text-muted-foreground">{getStatusText(file.status)}</p>
                                {file.status === 'uploading' && file.progress !== undefined && (
                                    <Progress value={file.progress} className="mt-2 h-2" />
                                )}
                            </div>
                            {file.error && (
                                <p className="text-xs text-red-500">{file.error}</p>
                            )}
                        </div>
                    ))}
                </div>

                {completedFiles + failedFiles === totalFiles && (
                    <div className="flex justify-end space-x-2 pt-4">
                        <button
                            onClick={onClose}
                            className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90"
                        >
                            Close
                        </button>
                    </div>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default UploadManagerDialog;